import React from 'react';
import { Image, Stack } from '@chakra-ui/react';

const Logo = ({isSmallScreen}) => {
  return (
    <Stack
      direction={isSmallScreen ? 'column' : 'row'}
      spacing={{ base: 0, md: 0}}
      align={{ base: 'center', md: 'center' }} // Align logos vertically at the center
      width={{ base: '100%', md: '100%', lg: '100%' }}
      mx="auto"      
      mb={{ base: 4, md: 4 }}
      mt={{ base: 4, md: 4 }} // Add some spacing on top
    >
      {/* Logos */}
      <Image
        width={{ base: '100%', md: '100%' }}
        src="/JKLogoBlack.webp"
        alt="Logo 1"
        style={{ height: '100px', objectFit: 'contain' }}
      />
      <Image
        width={{ base: '100%', md: '100%' }}
        src="/McGill.jpeg"
        alt="Logo 2"
        style={{ height: '50px', objectFit: 'contain' }}
      />
    </Stack>
  );
};

export default Logo;